import React from 'react';
import { Slice } from 'gatsby';

import Cart from '../Cart'

const Default = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col relative overflow-x-hidden bg-dnd-dark bg-[url('../images/bg-pattern.png')] bg-auto bg-repeat">
      {/* Header */}
      <Slice alias="header" />
      
      <Cart />
      
      {/* Main content */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer */}
      <div className="mt-auto">
        <Slice alias="footer" />
      </div>
    </div>
  );
}

export default Default;
